import React from "react";
import { Row, Col } from "antd";
import { googleAds } from "appConfig";

import CategoryTile from "./CategoryTile";
import styles from "./categorySelect.scss";
import GoogleAd from "../../../../components/GoogleAd";

function CategorySelect({ categories, path, isMobile }) {
  const renderGoogleAd = index => {
    if (isMobile && index % 6 === 2) {
      switch (index) {
        case 2:
          return (
            <GoogleAd
              className={styles.ads}
              config={{
                id: "googleAds.postAdMobile.box1",
                ...googleAds.postAdMobile.box1
              }}
            />
          );

        case 8:
          return (
            <GoogleAd
              className={styles.ads}
              config={{
                id: "googleAds.postAdMobile.box2",
                ...googleAds.postAdMobile.box2
              }}
            />
          );

        default:
          return (
            <GoogleAd
              className={styles.ads}
              config={{
                id: "googleAds.postAdMobile.box3",
                ...googleAds.postAdMobile.box3
              }}
            />
          );
      }
    }

    return null;
  };

  return (
    <Row gutter={20}>
      {categories.map((category, index) => (
        <Col key={category.name} xs={24} sm={24} md={12} lg={12} xl={8}>
          {renderGoogleAd(index)}
          <CategoryTile key={category.name} path={path} category={category} />
        </Col>
      ))}
    </Row>
  );
}

export default CategorySelect;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/SelectingCategory/CategorySelect/index.tsx